import type { Client, ClientStatus } from '../types'

function dateAt(daysFromNow: number, hour = 10): string {
  const date = new Date()
  date.setDate(date.getDate() + daysFromNow)
  date.setHours(hour, 0, 0, 0)
  return date.toISOString()
}

function client(
  company: string,
  contactPerson: string,
  phone: string,
  potential: number,
  status: ClientStatus,
  overrides: Partial<Client> = {},
): Client {
  const now = new Date().toISOString()
  return {
    id: crypto.randomUUID(),
    company,
    contactPerson,
    phone,
    email: '',
    city: 'Москва',
    segment: 'B2B',
    potential,
    status,
    important: false,
    attempts: status === 'new' ? 0 : 1,
    lastContactAt: status === 'new' ? null : dateAt(-5),
    nextContactAt: null,
    result: '',
    notes: '',
    interactions: [],
    createdAt: now,
    updatedAt: now,
    ...overrides,
  }
}

export function createDemoClients(): Client[] {
  return [
    client('ООО «Вектор»', 'Алексей Смирнов', '+7 999 120-42-10', 1_500_000, 'callback', {
      important: true,
      nextContactAt: dateAt(-1, 11),
      result: 'Просил вернуться после согласования бюджета.',
    }),
    client('ЭлектроСнаб', 'Марина Ковалева', '+7 926 455-18-27', 800_000, 'interested', {
      nextContactAt: dateAt(0, 15),
      result: 'Ждёт предложение и условия по отсрочке.',
    }),
    client('АО «Горизонт»', 'Илья Петров', '+7 495 602-11-30', 600_000, 'new'),
    client('МонтажПроект', 'Сергей Волков', '+7 903 719-03-44', 250_000, 'no_answer', {
      attempts: 2,
      lastContactAt: dateAt(-3),
    }),
    client('ТехноЛайн', 'Ольга Романова', '+7 916 100-55-08', 120_000, 'contacted', {
      result: 'Пока закупок нет, вернуться в следующем месяце.',
      nextContactAt: dateAt(21),
    }),
    client('ИП Соколов', 'Дмитрий Соколов', '+7 985 010-88-41', 50_000, 'not_interested', {
      result: 'Работает по действующему контракту с другим поставщиком.',
    }),
  ]
}
